import type { ComponentProps } from '@enonic/react-components'
import * as React from 'react'
import { Section, Container, ResponsiveImage } from '../primitives'
import type { ResponsiveImageData } from '../primitives'

interface TestimonialItemData {
  quote: string
  quotee: string
  image?: ResponsiveImageData
}

export interface TestimonialData extends Record<string, unknown> {
  testimonials: TestimonialItemData[]
  mirrored: boolean
  backgroundColor: 'none' | 'light-blue' | 'light-peach'
}

const bgMap: Record<TestimonialData['backgroundColor'], string> = {
  none: '',
  'light-blue': 'bg-slate-100',
  'light-peach': 'bg-peach-100',
}

export const Testimonial = (props: ComponentProps) => {
  const { testimonials, mirrored, backgroundColor } =
    props.data as TestimonialData

  if (!testimonials || testimonials.length === 0) return null

  const isTwoQuotes = testimonials.length > 1

  return (
    <Section background={bgMap[backgroundColor]}>
      <Container className="gap-y-20 md:gap-y-0">
        {isTwoQuotes ? (
          testimonials.map((item, index) => (
            <div
              key={index}
              className={`col-span-full md:col-span-5 flex flex-col gap-8 ${index === 0 ? 'md:col-start-2' : ''}`}
            >
              <div className="flex flex-col gap-3 md:order-2 md:gap-6">
                <blockquote className="font-serif text-2xl italic leading-normal text-black md:text-4xl md:leading-normal">
                  {item.quote}
                </blockquote>
                {item.quotee && (
                  <p className="text-xs leading-normal text-slate-900 md:text-base md:leading-normal">
                    <cite className="not-italic">{item.quotee}</cite>
                  </p>
                )}
              </div>
              {item.image && (
                <div className="md:order-1">
                  <ResponsiveImage
                    data={item.image}
                    className="w-full object-cover md:h-full"
                  />
                </div>
              )}
            </div>
          ))
        ) : (
          <>
            <div
              className={`col-span-full md:col-start-2 md:col-span-5 flex flex-col self-center gap-3 md:gap-6 ${mirrored ? 'md:order-2 md:col-start-7' : ''}`}
            >
              <blockquote className="font-serif text-2xl italic leading-normal text-black md:text-4xl md:leading-normal">
                {testimonials[0].quote}
              </blockquote>
              {testimonials[0].quotee && (
                <p className="text-xs leading-normal text-slate-900 md:text-base md:leading-normal">
                  <cite className="not-italic">{testimonials[0].quotee}</cite>
                </p>
              )}
            </div>
            {testimonials[0].image && (
              <div
                className={`col-span-full md:col-span-5 mt-8 md:mt-0 ${mirrored ? 'md:col-start-2 md:order-1' : ''}`}
              >
                <ResponsiveImage
                  data={testimonials[0].image}
                  className="w-full object-cover md:h-full"
                />
              </div>
            )}
          </>
        )}
      </Container>
    </Section>
  )
}
